import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { selectRole } from './selectors';
import { UserRole } from './types';

type Props = {
  disableForSuperAdmin?: boolean;
  placeholder?: React.ReactNode;
} & (
  | { role: UserRole; roles?: undefined }
  | { role?: undefined; roles: readonly UserRole[] }
);

export const RoleGuard: FC<Props> = ({
  disableForSuperAdmin,
  children,
  placeholder,
  role,
  roles,
}) => {
  const currentRole = useSelector(selectRole);
  const isPermitted = useMemo(
    () =>
      (!disableForSuperAdmin && currentRole === 'SUPER_ADMIN') ||
      [role, ...(roles || [])].findIndex((i) => i === currentRole) >= 0,
    [currentRole, role, roles],
  );

  return <>{isPermitted ? children : placeholder || null}</>;
};

export const RoleGuardLayout = (props: Props) => (
  <RoleGuard {...props} children={<Outlet />} />
);
